const PaginationLeftSmallIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        // fillRule="evenodd"
        // clipRule="evenodd"
        d="M14.2955 5.20451C13.8562 4.76517 13.1438 4.76517 12.7045 5.20451L6.70451 11.2045C6.49353 11.4155 6.375 11.7016 6.375 12C6.375 12.2984 6.49353 12.5845 6.70451 12.7955L12.7045 18.7955C13.1438 19.2348 13.8562 19.2348 14.2955 18.7955C14.7348 18.3562 14.7348 17.6438 14.2955 17.2045L9.09099 12L14.2955 6.7955C14.7348 6.35616 14.7348 5.64384 14.2955 5.20451Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PaginationLeftSmallIcon;
